const i18n = {
	search: {
		1 : 'Фильтры',
		0 : 'Фільтры'
	},
	save: {
		1 : 'Отправить приглашение',
		0 : 'Адправіць запрашэнне'
	},
	childOrgsTitle: {
		1 : 'Дочерние, вышестоящие и подведомственные организации',
		0 : 'Даччыныя, вышэйстаячыя і падведамасныя арганізацыі'
	},
	unp: {
		1 : "УНП",
		0 : "УНП"
	},
	orgNameTitle: {
		1 : "Наименование организации",
		0 : "Найменне арганізацыі"
	},
	parentChildsTitle: {
		1 : "Дочерние организации",
		0 : "Даччыныя арганізацыі"
	},
	confirmRemoveParentText: {
		1 : "Вы действительно хотите удалить выбранную организацию со списка дочерних?",
		0 : "Вы сапраўды хочаце выдаліць выбраную арганізацыю са спісу даччыных?"
	},
	addParentChild: {
		1 : "Добавить дочернюю организацию",
		0 : "Дадаць даччыную арганізацыю"
	},
	orgParentFor: {
		1 : "Ваша организация является дочерней для: ",
		0 : "Ваша арганізацыя з'яўляецца даччынай для: "
	},
	orgInstitutionFor: {
		1 : "Ваша организация является подведомственной для: ",
		0 : "Ваша арганізацыя з'яўляецца падведамнай для: "
	},
	addInstitutionChild: {
		1 : "Добавить подведомственную организацию",
		0 : "Дадаць падведамасную арганізацыю"
	},
	institutionChildsTitle: {
		1 : "Подведомственные организации",
		0 : "Падведамасныя арганізацыі"
	},
	searchByUNPorName: {
		1 : "Поиск по УНП или названию",
		0 : "Пошук па УНП або назве"
	},
	confirmRemoveInstitutionText: {
		1 : "Вы действительно хотите удалить выбранную организацию из списка подведомственных?",
		0 : "Вы сапраўды хочаце выдаліць выбраную арганізацыю са спісу падведамасных?"
	},
	listMenu: {
		1 : "Добавить / Удалить",
		0 : "Дадаць / Выдаліць"
	},
	childOrg: {
		1 : "Дочерние организации",
		0 : "Даччыныя арганізацыі"
	},
	superiorOrg: {
		1 : "Вышестоящие организации",
		0 : "Вышэйстаячыя арганізацыі"
	},
	confirmRemoveSuperiorOrg: {
		1 : "Вы действительно хотите удалить выбранную организацию из списка вышестоящих?",
		0 : "Вы сапраўды хочаце выдаліць выбраную арганізацыю са спісу вышэйстаячых?"
	},
	subOrg: {
		1 : "Подведомственные организации",
		0 : "Падведамныя арганізацыі"
	},
	sendHistoryMenu: {
		1 : "Отправленные запросы",
		0 : "Адпраўленыя запыты"
	},
	getHistoryMenu: {
		1 : "Полученные запросы",
		0 : "Атрыманыя запыты"
	},
	addInfo: {
		1 : "При добавлении организации в список подведомственных/дочерних, выбранной организации будет отправлен запрос. При потверждение запроса организация будет добавлена в указанный список.",
		0 : "Пры даданні арганізацыі ў спіс падведамных/ даччыных, абранай арганізацыі будзе адпраўлены запыт. Пры потверждение запыту арганізацыя будзе дададзеная ў паказаны спіс."
	},
	isAccepted: {
		1 : "Решение",
		0 : "Рашэнне"
	},
	creationDate: {
		1 : "Дата приглашения",
		0 : "Дата запрашэння"
	},
	startDate: {
		1 : "Дата создания от",
		0 : "Дата стварэння ад"
	},
	endDate: {
		1 : "Дата создания по",
		0 : "Дата стварэння да"
	},
	accept: {
		1 : "Принять",
		0 : "Прыняць"
	},
	dismiss: {
		1 : "Отклонить",
		0 : "Адхіліць"
	},
	acceptInvite: {
		1 : "Приглашение принято",
		0 : "Запрашэнне прынята"
	},
	reject: {
		1 : "Приглашение отклонено",
		0 : "Запрашэнне адхілена"
	},
	wait: {
		1 : "Приглашение ещё не просмотрено",
		0 : "Запрашэнне яшчэ не прагледжана"
	},
	invitationTitle: {
		1 : "Приглашение в дочернюю/подведомственную организацию",
		0 : "Запрашэнне ў даччыную/падведамных арганізацыю"
	},
	acceptAction: {
		1 : "Подтвердите действие",
		0 : "Пацвердзіце дзеянне"
	},
	subReOrgType: {
		1 : "Тип",
		0 : "Тып"
	},
	delete: {
		1 : "Удалить",
		0 : "Выдаліць"
	},
	addSuperiorOrgSuccessNotice : {
		1 : "Вышестоящая организация успешно добавлена",
		0 : "Вышэйстаячая арганізацыя паспяхова дададзена"
	},
	removeSuperiorOrgSuccessNotice : {
		1 : "Вышестоящая организация успешно удалена",
		0 : "Вышэйстаячая арганізацыя паспяхова выдалена"
	},
	spinText : {
		1 : "Поиск...",
		0 : "Пошук..."
	}
}

export default i18n
